import { ITrack } from "../Projects/MapData";
import { ResourceInfoDto, Track, TrackGroup } from "../api";

export interface ITrackView extends ITrack {
    subTracks: ITrack[] | null;
    ddpTrackDuration: number | null,
    ddpTrackTitle: string | null,
}

export const transformTrackGroups = (groups: TrackGroup[], hideDuration: boolean = false): ITrackView[] => {
    return groups.map(g => ({
        number: g.groupNumber,
        duration: hideDuration ? null : g.duration,
        title: "Track Group",
        versionTitle: "",
        isrc: "",
        subTracks: g.tracks,
        ddpTrackDuration: null,
        ddpTrackTitle: null,
    }));
};

export const transformTracks = (tracks: Track[]): ITrackView[] => {
    return tracks.map(t => ({
        number: t.number,
        duration: t.duration,
        title: t.title,
        versionTitle: t.versionTitle,
        isrc: t.isrc,
        subTracks: null,
        ddpTrackDuration: null,
        ddpTrackTitle: null,
    }));
};

export const transformResource = (resource: ResourceInfoDto): ITrackView[] => {
    return [{
        number: 0,
        duration: resource.duration,
        title: resource.title ?? "",
        versionTitle: resource.version,
        isrc: resource.isrc!,
        subTracks: null,
        ddpTrackDuration: null,
        ddpTrackTitle: null,
    }];
};
